import {EditableFieldView} from "./editable-field.view";
import {useEffect, useState} from "react";

export interface EditableFieldProps {
  onSubmit: (v: string | number) => void
  value: string | number
  label: string
}

export const EditableField = (props: EditableFieldProps) => {
  const [edit, setEdit] = useState<boolean>(false)


  const handleSubmit = (v: string | number) => {
    setEdit(!edit)

    props.onSubmit(v)
  }


  const handleCancel = () => {
    setEdit(false)
  }
  return (<EditableFieldView onCancel={handleCancel} label={props.label} isEditEnabled={edit} onSubmit={handleSubmit} value={props.value}/>)
}
